<!--
 * @Descripttion: 资讯编辑
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="information-mgmt-edit">
    <BaseForm
      style="
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        padding: 20px;
        overflow-y: auto;
      "
      ref="formRef"
      label-position="top"
      :model="formData"
      :rules="rules"
      :columnCount="2"
    >
      <BaseFormItem
        v-bind="BaseFormItemBaseConfig"
        label="资讯标题"
        prop="title"
      >
        <BaseInput
          placeholder="请输入资讯标题"
          style="width: 100%"
          v-model="formData.title"
          :maxlength="200"
          show-word-limit
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        v-bind="BaseFormItemBaseConfig"
        label="资讯作者"
        prop="author"
      >
        <BaseInput
          placeholder="请输入作者"
          style="width: 100%"
          v-model="formData.author"
          :maxlength="30"
          show-word-limit
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        style="flex-direction: column"
        label="列表封面图"
        prop="cover"
      >
        <BaseUpload
          style="width: 100%"
          ref="baseUploadRefCover"
          listType="picture-card"
          :accept="['.jpg', '.png', '.jpeg']"
          :limit="1"
          :limitSize="5"
          :autoUpload="true"
          :onError="onError"
          :httpRequest="
            e => {
              httpRequest(e, 'cover');
            }
          "
          v-model:fileList="formData.cover"
          @change="onChangeUpload('cover')"
        >
          <template #tip>
            <span style="color: #898989; font-size: 14px">
              5M以下的JPEG、PNG、JPG图片，建议尺寸比例为3:2
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        v-bind="BaseFormItemBaseConfig"
        label="是否上传视频"
        prop="contentType"
      >
        <BaseSelect
          v-model="formData.contentType"
          placeholder="请选择是否上传视频"
          :options="[
            { label: '是', value: 2 },
            { label: '否', value: 1 }
          ]"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem
        style="flex-direction: column"
        v-if="formData.contentType === 2"
        label="视频封面图"
        prop="videoCover"
      >
        <BaseUpload
          style="width: 100%"
          ref="baseUploadRefVideoCover"
          listType="picture-card"
          :limit="1"
          :limitSize="5"
          :autoUpload="true"
          :onError="onError"
          :httpRequest="
            e => {
              httpRequest(e, 'videoCover');
            }
          "
          v-model:fileList="formData.videoCover"
          @change="onChangeUpload('videoCover')"
        >
          <template #tip>
            <span style="color: #898989; font-size: 14px">
              5M以下的JPEG、PNG、JPG图片，建议尺寸比例为3:2
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        style="flex-direction: column"
        v-if="formData.contentType === 2"
        label="视频文件"
        prop="videoUrl"
      >
        <BaseUpload
          style="width: 100%"
          ref="baseUploadRefVideoUrl"
          :disabled="!!formData.videoLink"
          :accept="['.mp4']"
          :limit="1"
          :limitSize="1000"
          :autoUpload="true"
          :onError="onError"
          :httpRequest="
            e => {
              httpRequest(e, 'videoUrl');
            }
          "
          v-model:fileList="formData.videoUrl"
          @change="onChangeUpload('videoUrl')"
        >
          <template #tip>
            <span style="color: #898989; font-size: 14px">
              上传1G内的视频文件
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        style="flex-direction: column"
        v-if="formData.contentType === 2"
        label="视频链接"
        prop="videoLink"
      >
        <BaseInput
          :disabled="formData.videoUrl.length > 0"
          placeholder="请输入视频链接"
          style="width: 100%"
          v-model="formData.videoLink"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        v-bind="BaseFormItemBaseConfig"
        label="资讯正文"
        prop="content"
        style="grid-column-start: 1; grid-column-end: 3"
      >
        <XrkTinymce
          style="width: 100%"
          :value="formData.content"
          @input="onTinymceInput"
          :limitImgSize="[1000, 1500]"
        ></XrkTinymce>
      </BaseFormItem>
    </BaseForm>

    <div class="affix-box">
      <BaseButton type="default" @click="onCancelClick">取消</BaseButton>
      <BaseButton type="primary" @click="onSaveClick">保存</BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { useRoute, useRouter } from 'vue-router';
import XrkTinymce from '../../../../components/xrk/tinymce';
import { ref } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseFormProps,
  BaseFormRef,
  XrkMessage,
  BaseSelect,
  BaseUpload,
  createDialog
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { addOrUpdate, infoDetail } from '../data-source/apis';

const route = useRoute();
const id: number = +route.query?.id || null;
const router = useRouter();
const baseUploadRefCover = ref();
const baseUploadRefVideoCover = ref();
const baseUploadRefVideoUrl = ref();

const BaseFormItemBaseConfig = {
  'label-width': '110px',
  'label-position': 'top'
};

type DataType = {
  id?: number;
  title: string;
  author: string;
  cover: any[];
  videoCover: any[];
  videoUrl: any[];
  videoLink: string;
  contentType: number; //是否上传视频1否2是
  content: string;
};

type RichTextFormProps = BaseFormProps<DataType>;
const formRef = ref<BaseFormRef<DataType>>();

const onChangeUpload = key => {
  formRef.value.validateField(key);
};

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const httpRequest = ({ file }: { file: File }, key) => {
  return new Promise((resolve, reject) => {
    uploadApi({ file })
      .then(res => {
        formData.value[key][0].url = res.data.fileUrl;
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
const onTinymceInput = v => {
  formData.value.content = v;
  formRef.value.validateField('content');
};

const formData = ref<DataType>({
  title: '',
  author: '',
  cover: [],
  videoCover: [],
  videoUrl: [],
  videoLink: '',
  contentType: 1,
  content: ''
});
const rules: RichTextFormProps['rules'] = {
  title: { required: true, message: '请输入资讯标题' },
  author: { required: true, message: '请输入作者' },
  cover: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, _value, callback) => {
        if (!formData.value.cover.length) {
          return callback(new Error('请上传列表封面图'));
        }
        callback();
      }
    }
  ],
  contentType: {
    required: true,
    message: '请选择是否上传视频',
    trigger: 'change'
  },
  videoCover: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, _value, callback) => {
        if (!formData.value.videoCover.length) {
          return callback(new Error('请上传视频封面图'));
        }
        callback();
      }
    }
  ],
  content: { required: true, message: '资讯正文不能为空' }
};

const initData = async () => {
  const {
    data: {
      title,
      author,
      content,
      cover,
      videoUrl,
      videoCover,
      videoLink,
      contentType
    }
  } = await infoDetail({ id, hasForm: 1 });
  formData.value.title = title;
  formData.value.author = author;
  formData.value.content = content;
  if (videoCover) {
    if (videoUrl) {
      formData.value.videoUrl = [
        {
          url: videoUrl
        }
      ];
    } else {
      formData.value.videoLink = videoLink;
    }

    formData.value.videoCover = [
      {
        url: videoCover
      }
    ];
  }
  formData.value.cover = [
    {
      url: cover
    }
  ];
  formData.value.contentType = contentType;
};

const onCancelClick = () => {
  createDialog({
    width: 350,
    title: '提示',
    showClose: true,
    content: '当前页面有未保存内容，是否继续返回',
    beforeConfirm: async done => {
      done();
      router.back();
    }
  });
};

const onSaveClick = async () => {
  await formRef.value?.validate();
  await baseUploadRefCover.value.submit();
  if (formData.value.contentType === 2) {
    await baseUploadRefVideoCover.value.submit();
    await baseUploadRefVideoUrl.value.submit();
    if (!formData.value.videoUrl.length && !formData.value.videoLink) {
      return XrkMessage.error('请上传视频文件或输入视频链接');
    }
  }

  const params = {
    ...formData.value,
    id,
    cover: formData.value.cover[0].url,
    videoCover: formData.value.videoCover[0]?.url,
    videoUrl: formData.value.videoUrl[0]?.url,
    hasForm: 1
  };
  await addOrUpdate(params);
  XrkMessage.success('保存成功');
  router.back();
};
if (id) {
  initData();
}
</script>
<style lang="scss" scoped>
.information-mgmt-edit {
  padding: 0;
  display: flex;
  flex-direction: column;
}
</style>
